// on click scroll to newslatter PDP
$('#scrToNewslatter').click(function(){
  var target = $('#shopify-section-get-subscription');
   $('html,body').animate({
      scrollTop: $(target).offset().top - 180
   },'medium');
})

function accordion() {
    $('.faq_main .faq_que').click(function(){
        $(this).toggleClass('active');
        $(this).siblings().slideToggle(300);
    });
}

function calcHeight($mainHeight, $targetHeight) {
  var height = $('.site-header').height()+1;
  var announceHeight = $('.announcement-bar-link').length > 0 ? $('.announcement-bar-link').height() : -1;
  var mainHeight = height + announceHeight + 4;
  var scrollAnnouce = $(window).scrollTop() ;
  
  if( scrollAnnouce > announceHeight){
    $('.navmenu-submenu').css('top' , height);
  }else{
    $('.navmenu-submenu').css('top' , mainHeight);    
  }
}

function popup($trigger, $closeTrigger){
  $(document).delegate($trigger,'click',function(){
    $('body').addClass('popup-open');
  });
  $(document).delegate( $closeTrigger, 'click',function(){
    $('body').removeClass('popup-open');

  });
}

// execute functions

if ($(window).width() >= 1023 ){
  calcHeight();
  $(window).on('scroll', function(){
  	calcHeight();
  });
}

accordion();
popup('#size-guide','span#closePopup');

$(".store-code.select_store").on("click", function(){
  $(this).closest(".global-dropdown").find(".store-switcher-dropdown").toggleClass("active");
});
$(".previews_menu").on("click", function(){
  $(this).closest("li").find(".navmenu-button").trigger("click");
});

$(document).ready(function(){ 
  $(window).scroll(function(){ 
      if ($(this).scrollTop() > 100) { 
          $('#toTop').fadeIn(); 
      } else { 
          $('#toTop').fadeOut(); 
      } 
  }); 
  $('#toTop').click(function(){ 
      $("html, body").animate({ scrollTop: 0 }, 600); 
      return false; 
  }); 
});